<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="faq-search-filter">
      <div class="card faq-search" style="background-image: url('assets/images/banner/banner.png')">
        <div class="card-body text-center">
          <!-- main title -->
          <h2 class="text-primary">Rispondiamo ad alcune domande</h2>

          <!-- subtitle -->
          <p class="card-text mb-2">oppure scegli una categoria per trovare velocemente l'aiuto di cui hai bisogno</p>

          <!-- search input -->
          <form class="faq-search-input">
            <div class="input-group input-group-merge">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i data-feather="search"></i>
                </div>
              </div>
              <input
                type="text"
                [(ngModel)]="searchText"
                name="searchbar"
                class="form-control"
                placeholder="Cerca nelle faq..."
              />
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- account setting page -->
    <section id="faq">
      <div class="row nav-vertical d-flex">
        <div class="col-md-3 mb-2 mb-md-0">
          <ul ngbNav #navVertical="ngbNav" class="nav nav-pills flex-column nav-left">
            <li class="nav-item" ngbNavItem *ngFor="let topic of topics; let topic_i = index">
              <a
                ngbNavLink
                class="nav-link d-flex py-75"
                id="payment"
                data-toggle="pill"
                href="#faq-payment"
                aria-expanded="true"
                role="tab"
              >
                <i [data-feather]="topic.icon" class="font-medium-3 mr-1"></i>
                <span class="font-weight-bold">{{ topic.title }}</span>
              </a>

              <ng-template ngbNavContent>
                <!-- payment panel -->
                <div
                  role="tabpanel"
                  class="tab-pane active collapse-icon"
                  id="faq-payment"
                  aria-labelledby="payment"
                  aria-expanded="true"
                >
                  <!-- icon and header -->
                  <div class="d-flex align-items-center">
                    <div class="avatar avatar-tag bg-light-primary mr-1">
                      <i [data-feather]="topic.icon" class="font-medium-4"></i>
                    </div>
                    <div>
                      <h4 class="mb-0">{{ topic.title }}</h4>
                      <span>{{ topic.subtitle }}</span>
                    </div>
                  </div>

                  <!-- frequent answer and question  collapse  -->
                  <div class="accordion collapse-margin mt-2">
                    <ng-container *ngIf="(topic.qanda | filter: searchText:'question').length; else noResults">
                      <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" activeIds="topic{{topic_i}}-0">
                        <ngb-panel
                          id="topic{{topic_i}}-{{ i }}"
                          [cardClass]="'collapse-margin'"
                          *ngFor="let paymentRef of topic.qanda | filter: searchText:'question'; let i = index"
                        >
                          <ng-template ngbPanelTitle>
                            <span>{{ paymentRef.question }}</span>
                          </ng-template>
                          <ng-template ngbPanelContent>
                            <div [innerHTML]="paymentRef.answer"></div>
                          </ng-template>
                        </ngb-panel>
                      </ngb-accordion>
                    </ng-container>
                    <ng-template #noResults>
                      <div class="p-5 text-center">
                        <h5 class="p-1"><i data-feather="info" size="19" class="mr-25"></i> Nessun risultato trovato</h5>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </li>
            <!-- FAQ image -->
            <img
              src="assets/images/illustration/faq-illustrations.svg"
              class="img-fluid d-none d-md-block pt-5"
              alt="demand img"
            />
          </ul>
        </div>
        <div [ngbNavOutlet]="navVertical" class="col-12 col-md-9"></div>
      </div>
    </section>
    <!--/ account setting page -->

    <!-- contact us -->
    <section class="faq-contact">
      <div class="row mt-5 pt-75">
        <div class="col-12 text-center">
          <h2>Hai ancora delle domande?</h2>
          <p class="mb-3">
            Se non hai trovato la risposta che cercavi, contattaci e saremo lieti di aiutarti.
          </p>
        </div>
        <div class="col-sm-6">
          <a href="tel:+3901119510050" class="card text-center faq-contact-card shadow-none py-1">
            <div class="card-body">
              <div class="avatar avatar-tag bg-light-primary mb-2 mx-auto">
                <i data-feather="phone-call" class="font-medium-3"></i>
              </div>
              <h4>+ (39) 011 19510050</h4>
              <span class="text-body">Siamo felici di esserti utili!</span>
            </div>
          </a>
        </div>
        <div class="col-sm-6">
          <a href="mailto:support@tulero.it" class="card text-center faq-contact-card shadow-none py-1">
            <div class="card-body">
              <div class="avatar avatar-tag bg-light-primary mb-2 mx-auto">
                <i data-feather="mail" class="font-medium-3"></i>
              </div>
              <h4>support@tulero.it</h4>
              <span class="text-body">Se cerchi una risposta celere!</span>
            </div>
          </a>
        </div>
      </div>
    </section>
    <!--/ contact us -->
  </div>
</div>
